import React, {useEffect, useRef, useState} from "react";
import {Col, Row} from "antd";
import PropTypes from "prop-types";

import CarFunctionsForm from "../../../components/car/CarFunctionsForm";
import CarHardwareCard from "../../../components/car/CarHardwareCard";
import {getCarHardware} from "../../../helpers/car";
import {ucFirst} from "../../../helpers/misc";
import {messageType, showMessages} from "../../../helpers/message";

import {cardsGridColumn} from "../../../assets/styles";

const CarTelematics = ({carID}) => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);
    const [loading, setLoading] = useState(true);

    const [hardwareType, setHardwareType] = useState('None');
    const [hardwareID, setHardwareID] = useState(0);
    const [hardwareExternalID, setHardwareExternalID] = useState(0);
    const [refreshHardware, setRefreshHardware] = useState(false);

    const handleRefreshHardware = () => {
        setRefreshHardware(prevState => !prevState);
    }

    useEffect(() => {
        const fetchCarHardware = async () => {
            const abortSignal = abortSignalRef.current;
            setLoading(true);

            try {
                const data = await getCarHardware(carID, abortSignal);

                if (data.length !== 0 && abortSignal.aborted === false) {
                    setHardwareType(ucFirst(data.type));
                    setHardwareID(data.id);
                    setHardwareExternalID(data.external_id);
                } else {
                    setHardwareType('None');
                    setHardwareID(0);
                    setHardwareExternalID(0);
                }

                setLoading(false);
            } catch (error){
                showMessages(error.message, messageType.error);
                setLoading(false);
                if(error.status_code === 404) window.location.replace('/404');
            }
        }

        fetchCarHardware()
    }, [carID, refreshHardware])

    return (
        <Row gutter={16}>
            <Col {...cardsGridColumn}>
                <CarHardwareCard
                    carID={carID}
                    hardwareType={hardwareType}
                    hardwareExternalID={hardwareExternalID}
                    handleRefreshHardware={handleRefreshHardware}
                    loading={loading}
                />
            </Col>
            <Col {...cardsGridColumn}>
                <CarFunctionsForm
                    hardwareID={hardwareID}
                />
            </Col>
        </Row>
    )
}

CarTelematics.propTypes = {
    carID: PropTypes.number.isRequired,
}

export default CarTelematics;
